import React from "react"
import get from 'lodash/get'
import Main_menu from '../components/Main_menu'
import Footer from '../components/Footer'

class PageMain extends React.Component {
  render() {
    const posts = get(this, 'props.data.allMarkdownRemark.edges')
    return (
    <div className="page-container">
      <Main_menu />
      {posts.map(({ node }) => {
        return (
          <div id={'Section-' + node.frontmatter.id} key={'Section-' + node.frontmatter.id}
          dangerouslySetInnerHTML={{ __html: node.html }} />
        )
      })}
    </div>
    )
  }
}

export default PageMain

export const PageMainQuery = graphql`
  query PageMain {
    allMarkdownRemark(filter: {fields: {slug: {regex: "/Main-page/"}}}, sort: {fields: [frontmatter___id], order: ASC}, limit: 1000) {
      edges {
        node {
          html
          fields {
            slug
          }
          frontmatter {
            title
            id
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js